import { Box, Text } from '@factorialco/deprecated-design-system'
import DOMPurify from 'dompurify'

import type { Message } from 'modules/finance/hooks/useMessage'

interface Props {
  message: Message
}

const MessageContent = ({ message }: Props) => {
  if (!message) return null

  const { content } = message

  return (
    <Text.Normal overflowWrap>
      <Box width="full" gap="s8">
        <div
          className=".candidates-message-board-reset-style"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
        />
      </Box>
    </Text.Normal>
  )
}

export default MessageContent
